import { InvoiceV1DetailApp } from "invoice/detail/App";
import { NewInvoiceApp } from "invoice/new/App";
import { MakeCreditApp } from "invoice/makecredit/App";
import { CopyInvoiceApp } from "invoice/copy/App";
import InvoiceListApp from "invoice/list/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const invoiceRoute: RouteObject = {
  children: [{
    path: "invoice",
    loader: () => viewModel,
    Component: InvoiceListApp,
  }, {
    path: "invoice/new",
    loader: () => viewModel,
    Component: NewInvoiceApp,
  }, {
    path: "invoice/detail/:key",
    loader: () => viewModel,
    Component: InvoiceV1DetailApp,
  }, {
    path: "invoice/makecredit/:key",
    loader: () => viewModel,
    Component: MakeCreditApp,
  }, {
    path: "invoice/copy/:key",
    loader: () => viewModel,
    Component: CopyInvoiceApp,
  }]
};